import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

export enum linIcon {
  Youtube = 'youtube',
  Facebook = 'facebook',
  Instagram = 'instagram',
  LinkedIn = 'linkedIn',
  File = 'file',
  Link = 'link',
  Code = 'code',
  Text = 'text',
}

export const linIconPath: {
  [key in linIcon]: string;
} = {
  [linIcon.Youtube]: '/assets/img/youtube.svg',
  [linIcon.Facebook]: '/assets/img/facebook.svg',
  [linIcon.Instagram]: '/assets/img//instagram.svg',
  [linIcon.LinkedIn]: '/assets/img/linkedIn.svg',
  [linIcon.File]: '/assets/img/pdf.svg',
  [linIcon.Link]: '/assets/img/company/icons/link.svg',
  [linIcon.Code]: '/assets/img/code.svg',
  [linIcon.Text]: '/assets/img/text-snippet.svg',
};

@Injectable({
  providedIn: 'root',
})
export class LinMatIconRegistryService {
  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);

  constructor() {
    Object.values(linIcon).forEach((iconName) => {
      this.matIconRegistry.addSvgIcon(
        iconName,
        this.safeUrl(linIconPath[iconName])
      );
    });
  }

  private safeUrl(string: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(string);
  }
}
